import { axios } from '@/utils/request'

const api = {
  channel: '/enterprise/channel',
  company: '/enterprise/management'
}

export function getSlectCombox (parameter) {
  return axios({
    url: api.company + '/selectCombox',
    method: 'get',
    params: parameter
  })
}

export function getChannelList (parameter) {
  return axios({
    url: api.channel + '/queryChannel',
    method: 'get',
    params: parameter
  })
}

export function saveChannel (parameter) {
  return axios({
    url: api.channel+(parameter.channelId == 0 ? '/addChannel' : '/editChannel'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function deleteChannel (parameter) {
  return axios({
    url: api.channel + '/deleteChannel',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//禁用
export function forbiddenBrand (parameter) {
  return axios({
    url: api.channel + '/forbiddenBrand',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//启动
export function enableChannel (parameter) {
  return axios({
    url: api.channel + '/enableChannel',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const channelExport = api.channel + '/export'
